import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    -webkit-tap-highlight-color: transparent;
  }

  html, body, #root {
    width: 100%;
    height: 100%;
    font-family: 'Noto Sans KR', sans-serif;
    background-color: #1a4d2e;
    touch-action: manipulation;
    overflow: hidden;
    position: fixed;
  }

  button {
    cursor: pointer;
    border: none;
    outline: none;
    background: none;
    touch-action: manipulation;
    user-select: none;
    -webkit-user-select: none;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  ul, ol, li {
    list-style: none;
  }
  
  /* 모바일 최적화 */
  @media (max-width: 768px) {
    html {
      font-size: 16px;
    }
  }
  
  @media (max-width: 480px) {
    html {
      font-size: 14px;
    }
  }
  
  /* 터치 이벤트 최적화 */
  input, button, a, div {
    touch-action: manipulation;
  }
  
  /* 스크롤바 스타일링 */
  ::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
  
  ::-webkit-scrollbar-track {
    background: #0a2918;
    border-radius: 2px;
  }
  
  ::-webkit-scrollbar-thumb {
    background: #f8cb66;
    border-radius: 2px;
  }
`;

export default GlobalStyle;
